<template>
    <controller>    
        <page-header title="Negocie Já - Negociações Efetivadas">
            <template v-slot:side>
            </template>
        </page-header>
        <efetivadas/>
    </controller>
</template>
<script>

import Efetivadas from '@/components/financeiro/negocieja/efetivadas/Efetivadas.vue'
export default {
    components: {
        Efetivadas
    }
}

</script>
<style lang="scss" scoped>
    
</style>